<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Measurement List</h2>
        </div>  
         <div class="card p-4">
            <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 lg:space-x-4">
                <!-- Start Date -->
                <div class="w-full lg:w-auto">
                    <label for="startDate" class="block text-sm font-medium text-gray-700 ">From Date</label>
                    <input
                        type="date"
                        id="startDate"
                        v-model="filter.startDate"
                        class="w-full p-2 border border-gray-300 rounded "
                    />
                </div>

                <!-- End Date -->
                <div class="w-full lg:w-auto">
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">To Date</label>
                    <input
                        type="date"
                        id="endDate"
                        v-model="filter.endDate"
                        class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded "
                    />
                </div>

            

                

                                   <div class="w-full lg:w-auto ml-4 mb-8" >
                                            <label for="customer" class="form-label">Search Customer</label><br>
                                            <select class="form-select form-select-sm" id="customer" ref="customer" v-model="filter.custid">
                                                <option value=""></option>
                                                <option v-for="(item, index) in customerList" :key="index" :value="item.id"> {{ item.name }} / {{ item.cell }}</option>
                                            </select>
                                        </div>





                <!-- Filter Button -->
                <div class="w-full lg:w-auto flex justify-center lg:justify-start">
                    <button
                        type="submit"
                        @click="getFilterBasics"
                        class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer"
                    >
                        Filter
                    </button>
                </div>


                 <div class="col-span-full lg:col-span-4 leading-none ml-5">
                        <label for="" class="form-label">Bill No *</label>
                        <input type="number" id="barcode" v-model="filterwise.billno"  @input="onBillNoChange" placeholder="Type Here Bill No."
                            class="form-input" required autocomplete="off">
                    </div>




            </div>


    




    <!-- Vendor Filter: Branch -->
    <!--<div class="w-full lg:w-auto" style="width: 250px;">-->
    <!--    <label for="ledger_name" class="block text-sm font-medium text-gray-700">Search Ledger</label>-->
    <!--    <select class="form-input w-full p-2 border border-gray-300 rounded" id="ledger_name" ref="ledger_name" v-model="sale.selected_leadgerId">-->
    <!--        <option value=""></option>-->
    <!--        <option value="All">ALL</option>-->
    <!--        <option v-for="(item, index) in  ledgerList" :key="index" :value="item.id">{{ item.name }}</option>-->
    <!--    </select>-->
    <!--</div>-->


        </div>



            <!-- <div class="card">

                            <div class="row" style="display: flex; gap: 1rem;">

                       

                       <div class="mt-6">
                            <button @click="show_status_measurment(1)" class="btn b-solid btn-danger-solid cursor-pointer shadow-sm">Stiching Sale</button>
                        </div> 


                       <div class="mt-6">
                            <button @click="show_status_measurment(2)" class="btn b-solid btn-warning-solid cursor-pointer shadow-sm">Regular Sale</button>
                        </div> 




                    </div>
                    </div> -->









        <div class="grid grid-cols-12">

               
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4 overflow-x-auto">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Bill No</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Customer Name</th>
                                    <th class="bg-[#B2E8D9]">Half Shirt</th>
                                    <th class="bg-[#B2E8D9]">Full Shirt</th>
                                    <th class="bg-[#B2E8D9]">Pant</th>
                           
                                    <th class="bg-[#B2E8D9]">Salesperson</th>
                                    <th class="bg-[#B2E8D9] col-span-3">Operation</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in measurement_list" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.entry_date}}</td>
                                    <td @click="filterCustomer(item.custid)">{{item.cust_name}} <span v-if="item.invoice_number > 0">/{{item.invoice_number}}</span></td>
                                     <td>{{item.halfshirt}}</td>
                                    <td>{{item.fullshirt}}</td>
                                     <td>{{item.pant}}</td>
                                
                                    <td class="text-info">{{item?.salesperson_name}}</td>
                                    <td  >
                                            <div class="flex items-center gap-1">


                                 


                                   

                                    <button class="btn-icon btn-primary-icon-light size-7" @click="print_measurement(item.id)" >
                                                                                <i class="ri-file-text-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                                                </button>


                                                                               
                                                                                       <button class="btn-icon btn-primary-icon-light size-7" @click="order_ready_whatsapp(item.id)" >
                                                                                    <i class="ri-whatsapp-fill text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                                                    </button>

                            







                                            </div>
                                    </td>
                                </tr>
                            </tbody>
                            
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->

        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->





    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->


   <!-- Modal -->
<div v-if="showModel" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-2xl shadow-lg w-full max-w-md mx-auto border-2 border-black" style="background-color: antiquewhite;">
    <div class="flex justify-between items-center p-4 border-b">
      <h2 class="text-lg font-semibold">Order Status</h2>
      <button @click="closeModel" class="text-gray-500 hover:text-gray-700 text-2xl leading-none">&times;</button>
    </div>
    <div class="p-2">
      <!-- <p class="text-gray-700">Modal body text goes here.</p> -->
     <div class="p-6 space-y-4">
  <div class="overflow-x-auto"  v-if="orderstatus.length > 0" >

    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-xl">
      <thead class="bg-gray-100 dark:bg-gray-700">
        <tr>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">#</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Product Name</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Qty</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Delivery Date</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Tailor Assign</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Status</th>
        </tr>
      </thead>
      <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700">
        <tr v-for="(item, index) in orderstatus" :key="item.id">
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ index + 1 }}</td>
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ item.stich_name }} ({{ item.prd_name }})</td>
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ item.pieceqty }} ({{ item.meterqty }})</td>
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ item.deliverydate === '0000-00-00' ? '--' : item.deliverydate }}</td>
          <td class="px-4 py-2 text-danger">{{ item.tailor_name || 'No Tailor' }}</td>
          <td class="px-4 py-2">
            <span :class="{
              'text-danger': item.markstatus == 0,
              'text-warning': item.markstatus == 1,
              'text-success': item.markstatus == 2
            }">
              {{ item.markstatus == 0 ? 'Pending' : item.markstatus == 1 ? 'Processing' : 'Complete' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <!-- Prism Code (optional / hidden block) -->
  <div class="p-6 hidden">
    <pre>
      <code class="language-markup">
        &lt;p&gt;Sorry we can't show the huge data&lt;/p&gt;
      </code>
    </pre>
  </div>
</div>

    </div>
    <!-- <div class="flex justify-end gap-2 p-4 border-t">
      <button @click="closeModel" class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Close
      </button>
      <button class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Save changes
      </button>
    </div> -->
  </div>
</div>









<div v-if="showOrderComplete" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-2xl shadow-lg w-full max-w-md mx-auto border-2 border-black" style="background-color: antiquewhite;">
    <div class="flex justify-between items-center p-4 border-b">
      <h2 class="text-lg font-semibold">Whatsapp Message</h2>
      <button @click="close_showOrderComplete()" class="text-gray-500 hover:text-gray-700 text-2xl leading-none">&times;</button>
    </div>
    <div class="p-2">
      <!-- <p class="text-gray-700">Modal body text goes here.</p> -->
     <div class="p-6 space-y-4">
  <div class="overflow-x-auto"    >
        <button @click="sendOrderReadyMessage"   class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">
             <i class="ri-whatsapp-fill text-white text-[14px]"></i> Send Order Ready Message
        </button>
        
         <button @click="sendOrderReadyMessage(1)"   class="btn b-solid btn-success-solid cursor-pointer shadow-sm mt-3">
             <i class="ri-whatsapp-fill text-white text-[14px]"></i> Send Order PDF File
        </button>
        
        
        <p class="text-danger">{{whatsapp_message}}</p>
        
    
  </div>


  <!-- Prism Code (optional / hidden block) -->
  <div class="p-6 hidden">
    <pre>
      <code class="language-markup">
        &lt;p&gt;Sorry we can't show the huge data&lt;/p&gt;
      </code>
    </pre>
  </div>
</div>

    </div>
    <!-- <div class="flex justify-end gap-2 p-4 border-t">
      <button @click="closeModel" class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Close
      </button>
      <button class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Save changes
      </button>
    </div> -->
  </div>
</div>







</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';
import Swal from 'sweetalert2'

export default {
name: 'measurement_list',
components: {

} ,
mounted(){


    if (this.$route.query.q) {
           this.getBasics(this.$route.query.q);
    }else{
       this.getBasics();
    }
},
data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
   //  startDate: this.getStartDate(),//new Date(Date.now() - 7 * 86400000).toISOString().split('T')[0],
    // endDate: today,
     measurement_list:[],
     orderstatus:[],
     showModel:false,
     showOrderComplete:false,
     current_whatsapp_order:0,
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
     Final:{total:0,paid:0,payable:0,disc:0},

        filter:{
        startDate:this.getStartDate(),
        endDate:today,
        status:'',
        custid:''
     },
     whatsapp_message:'',

     customerList:[],
     setting:[],
     filterwise:{
        billno:''
     }
     ,
     tmp_filter_list:[],
 }
 },
methods:{
     getStartDate() {
      let startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      //startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },

 closeModal(){

    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

    // print_invoice(id)
    //     {

    //            // window.open('/print?q='+id, '_blank');
    //            if(this.setting[0].settingvalue=="Thermal")
    //                 window.open('/thermalPrint?q='+id, '_blank');
    //             else
    //                 window.open('/A4?q='+id, '_blank');
    //     },

       print_invoice_A4(id)
        {
                    window.open('/A4?q='+id, '_blank');
        },

        print_invoice_thermal(id)
        {
                    window.open('/thermalPrint?q='+id, '_blank');
             
        },
        close_showOrderComplete(){
          this.showOrderComplete  =false;
          this.whatsapp_message  ='';
        },
 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },

 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 refreshDatatble() {
               self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            "order": [] 
                            });
         },
          destroyDatatble() {
                 if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }
          },

        //   self.datatable= $(".datatable").DataTable({
        //                     "paging": true,
        //                     "ordering": true,
        //                     "autoWidth": false });
 async getBasics(id) {
       var self=this;
         axios.post('get_measurement_list',{id:id}).then(function (response) {
                self.destroyDatatble();
                 self.measurement_list=response.data.measurement_list;
                 self.employees=response.data.userDetails;
                 self.customerList=response.data.customerList;
                 self.setting=response.data.setting;
                }).then(()=>{
                    self.refreshDatatble();








            $("#customer").select2({
                                    width: '250px', 
                                    placeholder:"Search Customer Here...",
                                "language": {
                                            "noResults": function(){
                                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                            }
                                        },
                                            escapeMarkup: function (markup) {
                                                return markup;
                                            }
                                }).on('change', function (event) {
                                //  alert(event.target.value);
                                         self.filter.custid=event.target.value; 
                                                
                                        
                                        
                                    // self.calculateTotals();            
                                        
                                    });












         








                    });
  },
 async filterCustomer(custid) {
       var self=this;
         axios.post('getCustomerSales',{custid:custid}).then(function (response) {
             self.destroyDatatble();
                 self.measurement_list=response.data.measurement_list;
                 self.employees=response.data.userDetails;

                }).then(()=>{
                  self.refreshDatatble();
           
                });
  },
            delete_category() {
                var self = this;
                axios.post('deleteProduct', {deleteId:this.deleteId})
                    .then(response => {
                        self.measurement_list=response.data.products;
                        self.employees=response.data.userDetails;
                         self.closeModal();
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },

  print_measurement(id)
        {

               // window.open('/print?q='+id, '_blank');
                window.open('/new_measurement_print?q='+id, '_blank');
        },

        show_status(id){
           // alert("hello");
         this.showModel=true;

            var self=this;
                    axios.post('getorderstatus',{id:id}).then(function (response) {
                            self.destroyDatatble();
                           // self.measurement_list=response.data.measurement_list;
                           // self.employees=response.data.userDetails;
                            self.orderstatus=response.data.orderstatus;
                            }).then(()=>{
                                self.refreshDatatble();

                                self.calculateTotal();
                                });

        },  
        
        sendOrderReadyMessage(para=0){
         
            var self=this;
            if(para==1){
                  axios.post('sendNewOrderMessage',{order_id:self.current_whatsapp_order}).then(function (response) {
                                if(response.data?.message_status=="accepted"){
                                    self.whatsapp_message="Message sent to "+response.data?.whatsapp_id;
                                }else{
                                    self.whatsapp_message=response.data?.error;
                                }
                            }).then(()=>{
                                
                                });
            }else{
                    axios.post('sendOrderReadyMessage',{order_id:self.current_whatsapp_order}).then(function (response) {
                                if(response.data?.message_status=="accepted"){
                                    self.whatsapp_message="Message sent to "+response.data?.whatsapp_id;
                                }else{
                                    self.whatsapp_message=response.data?.error;
                                }
                            }).then(()=>{
                                
                                });
                }
        },
        
        
        closeModel() {
            this.showModel = false;
        },
          
        order_ready_whatsapp(id){
            this.showOrderComplete=true;
            this.current_whatsapp_order=id;
            
        },
        
        
  getFilterBasics() {
       var self=this;
         axios.post('get_Filter_measurement_list',self.filter).then(function (response) {
                self.destroyDatatble();
                self.tmp_filter_list=[];
                 self.measurement_list=response.data.measurement_list;
                 self.employees=response.data.userDetails;
                }).then(()=>{
                    self.refreshDatatble();

          
                    });
  },

    onBillNoChange() {
var self=this;
         axios.post('get_Filter_invoice_no',self.filterwise).then(function (response) {
                self.destroyDatatble();
                 self.measurement_list=response.data.measurement_list;
                 self.employees=response.data.userDetails;
                 self.customerList=response.data.customerList;
                 self.setting=response.data.setting;
                }).then(()=>{
                    self.refreshDatatble();


                      }); 
 
    },
    filterSalesPerson(salesperson_is){
         
          var self=this;
          self.tmp_filter_list=[];
          
         self.destroyDatatble();
         self.measurement_list=self.measurement_list.filter(item => item.salesperson == salesperson_is);
         
          let total = 0;
      let disc = 0;
      let payable = 0;
      let paid = 0;
      
          self.measurement_list.forEach(item => {
                    total += Number(item.total || 0);
                    disc += Number(item.discount || 0);
                    payable += Number((item.total-item.discount) || 0);
                    paid += Number(item.paid || 0);
                  });
                  
                   self.Final = { total, disc, payable, paid };
        self.$nextTick(() => {
             self.refreshDatatble();
             
 
        });
    },
    show_status_measurment(id){
            
            var self=this;
            self.destroyDatatble();
            if(self.tmp_filter_list.length==0)
                self.tmp_filter_list=self.measurement_list;
            else 
                self.measurement_list=self.tmp_filter_list;
                
                
            if(id==1){
                 self.measurement_list=self.measurement_list.filter(item => item.ismeasurement == 1);
            }else{
                 self.measurement_list=self.measurement_list.filter(item => item.ismeasurement == 0);
            }
            
            
            self.$nextTick(() => {
                self.refreshDatatble();
        
            });
            
    //     if(id==1){
    //          var self=this;
    //      axios.post('getSales').then(function (response) {
    //             self.destroyDatatble();
    //              self.measurement_list=response.data.measurement_list.filter(item => item.ismeasurement == 1);
    //              self.employees=response.data.userDetails;
    //              self.customerList=response.data.customerList;
    //              self.setting=response.data.setting;
    //             }).then(()=>{
    //                 self.refreshDatatble();
       


    //                 self.calculateTotal();

    //                 });



    //     }else if(id==2){


    // var self=this;
    //         axios.post('getSales').then(function (response) {
    //                 self.destroyDatatble();
    //                 self.measurement_list=response.data.measurement_list.filter(item => item.ismeasurement == 0);
    //                 self.employees=response.data.userDetails;
    //                 self.customerList=response.data.customerList;
    //                 self.setting=response.data.setting;
    //                 }).then(()=>{
    //                     self.refreshDatatble();



    //                     self.calculateTotal();

    //                     });



    //     }




    },



         edit_sale_list(id){
            
            this.$router.push(`/saleview?id=${id}`);
                            
                        },


              async delete_sale_list(id) {
    const self = this;

    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!"
    }).then((result) => {

        if (result.isConfirmed) {

            axios.post('delete_sale_record', { id: id })
                .then(function (response) {

                    self.destroyDatatble();

                    self.measurement_list = response.data.measurement_list;
                    self.employees = response.data.userDetails;
                    self.customerList = response.data.customerList;
                    self.setting = response.data.setting;

                    if (response.data.reply == 1) {
                        Swal.fire("Success", response.data.message, "success");
                    } else {
                        Swal.fire("Error", response.data.message, "error");
                    }

                    self.refreshDatatble();

                })
                .catch(function () {
                    Swal.fire("Error", "Something went wrong!", "error");
                });

        }
    });
}






















}
}
</script>
